const Scroller = require('../../module/scroller');

/**
 * Anchor
 * @class
 */
class Anchor {

  /**
   * @static
   */
  static get defOpts() {
    return {
      duration: 600,
      easing  : 'easeOutQuad',
      offset  : 0,
    }
  }

  /**
   * @param _$el {HTMLElement}
   * @param _opts {object}
   */
  constructor(_$el, _opts = {}) {
    const opts_ = _.defaults(_opts, Anchor.defOpts);

    let href_ = _$el.getAttribute('href');
    if(!href_) {
      href_ = _$el.getAttribute('xlink:href');
    }
    if(!href_) return;

    if(location.href.match(/^([a-z0-9./-_]*)[#?]?.*$/)[1] !== href_.match(/^([a-z0-9./-_]*)[#?]?.*$/)[1]) {
      return;
    }

    // if(_$el.dataset.anchor === 'false') return;

    this.scroller = new Scroller(_$el, opts_);

    _$el.addEventListener('click', this.onClicked.bind(this));
  }

  /**
   * @private
   * @param _e {event}
   */
  onClicked(_e) {
    const $el_ = _e.currentTarget;
    let href_ = $el_.getAttribute('href');
    if(!href_) {
      href_ = $el_.getAttribute('xlink:href');
    }

    if(!href_) return;

    if(location.href.match(/^([a-z0-9./-_]*)[#?]?.*$/)[1] !== href_.match(/^([a-z0-9./-_]*)[#?]?.*$/)[1]) {
      return;
    }

    const hash_ = href_.match(/^.*(#.*)$/);

    if(!hash_) return;

    _e.preventDefault();

    const target_ = (hash_[1] === '#') ? 'html, body' : hash_[1];
    this.scroller.run(document.querySelectorAll(target_));
  }

}

/**
 * class exports
 */
module.exports = Anchor;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/pc/ui/anchor.js
 **/